import { FC, useState } from "react";
import {
    Box,
    Flex,
    Button,
    Text,
    Icon,
    Collapse,
    Picture,
} from "@smile2impress/components/relaunch";
import {
    ChevronRightSmallIcon,
    MinusFilledSmallIcon,
    PlusFilledSmallIcon,
} from "@smile2impress/components";

import Link from "components/Link";

import { MenuItemProps } from "./MenuItem.types";

export const MenuItem: FC<MenuItemProps> = ({
    text,
    link,
    items = [],
    highlighted,
}) => {
    const evenItems = items.length % 2 === 0;
    const collapsable = items.length && !link;
    const [isOpen, setOpen] = useState(highlighted || false);

    return (
        <Flex direction="column" mb={1}>
            <Button
                variant="ghost"
                justifyContent="space-between"
                display="flex"
                h="28px"
                mb={0.5}
                px={0}
                {...(collapsable && {
                    onClick: () => setOpen((prev) => !prev),
                })}
                {...(!collapsable && {
                    as: Link,
                    href: link,
                })}
            >
                <Text
                    textStyle="caption"
                    color="text.baseInverse"
                    _dark={{ color: "text.base" }}
                    fontWeight="bold"
                    as="span"
                >
                    {text}
                </Text>

                <Icon
                    as={
                        collapsable
                            ? isOpen
                                ? MinusFilledSmallIcon
                                : PlusFilledSmallIcon
                            : ChevronRightSmallIcon
                    }
                    w={collapsable ? 0.7 : 1}
                    h={collapsable ? 0.7 : 1}
                    color="text.baseInverse"
                    _dark={{ color: "text.base" }}
                />
            </Button>
            <Box bgColor="base.white" opacity="0.1" h="1px" />
            <Collapse in={isOpen} animateOpacity>
                <Flex
                    gap={1}
                    flexWrap="wrap"
                    justifyContent="center"
                    pt={1}
                    mb={2}
                >
                    {items.map((item, index) => (
                        <Link
                            display="flex"
                            href={item.link}
                            key={index}
                            textAlign="center"
                            flexDirection="column"
                            alignItems="center"
                            flexBasis={evenItems ? "35%" : `calc(33% - 14px)`}
                        >
                            <Box
                                display="inline-block"
                                as="span"
                                position="relative"
                                overflow="hidden"
                                borderRadius="50%"
                                h={4}
                                w={4}
                                mb="8px"
                            >
                                <Box
                                    as="span"
                                    position="absolute"
                                    bgColor="base.halfBlack"
                                    opacity="0.5"
                                    top="0"
                                    left="0"
                                    h={4}
                                    w={4}
                                    zIndex={0}
                                ></Box>
                                <Picture
                                    {...item.image}
                                    position="relative"
                                    zIndex={1}
                                />
                            </Box>
                            <Text
                                color="text.baseInverse"
                                _dark={{ color: "text.base" }}
                                textStyle="caption"
                                fontWeight="bold"
                                whiteSpace="wrap"
                                as="span"
                            >
                                {item.text}
                            </Text>
                        </Link>
                    ))}
                </Flex>
                <Box bgColor="base.white" opacity="0.1" h="1px" />
            </Collapse>
        </Flex>
    );
};
